import { PageHero } from "@/components/PageHero";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/motion";
import { usePageMeta } from "@/lib/seo";

export const PrivacyPolicy = () => {
    const { t } = useLang();
    const SECTIONS = [
        {
            h: t("privacy.s1.h", "1. Who we are"),
            p: [
                t("privacy.s1.p1", "UniversHeal is a healthcare coordination service for international patients, operating with its first market in Kerala, India. This policy explains how we handle personal information collected through this website."),
                t("privacy.s1.p2", "[Placeholder — registered legal entity name, address and registration details will be published here before launch.]"),
            ],
        },
        {
            h: t("privacy.s2.h", "2. Information we collect"),
            p: [
                t("privacy.s2.p1", "When you submit an enquiry through this website, we collect the information you provide: your name, email address, phone number, country of residence, area of care, and the details of your message. If you choose to share medical information or reports, we handle that information as confidential health-related data."),
            ],
        },
        {
            h: t("privacy.s3.h", "3. How we use your information"),
            p: [
                t("privacy.s3.p1", "We use your information to respond to your enquiry, coordinate specialist consultations and healthcare services you request, communicate with you about your care journey, and improve our services. We do not sell your personal information to anyone, for any purpose."),
            ],
        },
        {
            h: t("privacy.s4.h", "4. Sharing your information"),
            p: [
                t("privacy.s4.p1", "Your information is shared only with the specialists, hospitals and local partners involved in coordinating your requested services — and only to the extent needed for your care journey. Where you share medical information, we share it with the providers relevant to your enquiry."),
            ],
        },
        {
            h: t("privacy.s5.h", "5. Data retention"),
            p: [
                t("privacy.s5.p1", "We keep enquiry information for as long as needed to respond to your request and, where you become a coordinated patient, for the duration of the coordination relationship and any applicable follow-up period, after which information is securely deleted or anonymised unless retention is required by law."),
            ],
        },
        {
            h: t("privacy.s6.h", "6. Your rights"),
            p: [
                t("privacy.s6.p1", "You may ask us to access, correct or delete the personal information we hold about you, or withdraw consent for us to contact you. To exercise these rights, contact us through this website. [Placeholder — contact details for data-protection requests will be published before launch.]"),
            ],
        },
        {
            h: t("privacy.s7.h", "7. Security"),
            p: [
                t("privacy.s7.p1", "We apply reasonable technical and organisational measures to protect personal information. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security."),
            ],
        },
        {
            h: t("privacy.s8.h", "8. Changes to this policy"),
            p: [
                t("privacy.s8.p1", "We may update this policy from time to time. The current version will always be published on this page."),
            ],
        },
    ];
    usePageMeta(
        t("meta.privacy_policy.title", "Privacy Policy"),
        t("meta.privacy_policy.desc", "How UniversHeal collects, uses and protects the personal and medical information of international patients.")
    );
    return (
        <>
            <PageHero
                eyebrow={t("legal.eyebrow", "Legal")}
                title={t("privacy.title", "Privacy Policy")}
                intro={t("privacy.intro", "Your trust matters — especially with health-related information. This policy explains what we collect and how we protect it.")}
            />
            <section className="section-pad pt-6">
                <div className="container-site max-w-3xl">
                    <Reveal>
                        <p className="text-xs leading-relaxed text-moss bg-sage/70 border border-pine/10 rounded-2xl px-5 py-4 mb-12">
                            {t("legal.draftNote", "[Draft for review before launch — Last updated: placeholder date.]")}
                        </p>
                    </Reveal>
                    {SECTIONS.map((s, si) => (
                        <Reveal key={si}>
                            <div className="mb-10" data-testid={`privacy-${si + 1}`}>
                                <h2 className="font-serif font-medium text-2xl sm:text-3xl text-forest">
                                    {s.h}
                                </h2>
                                {s.p.map((para, i) => (
                                    <p
                                        key={i}
                                        className="mt-4 text-[15px] leading-relaxed text-charcoal/80"
                                    >
                                        {para}
                                    </p>
                                ))}
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>
        </>
    );
};
